import React from 'react';

import classes from './ModuleScheduleTab.module.css';

import { IsListEmpty, IsObjectEmpty, IsStringEmpty, GetFromLocalStorage } from '../../../../utilities/CommonMethods';
import WeekDayCard from '../../../Cards/WeekDayCard/WeekDayCard';
import ResourceAPIController from '../../../../webServices/ResourceAPIController';
import ShowLoader from '../../../../hoc/ShowLoader/ShowLoader';
import CreateNewAssignmentForm from '../../../Forms/CreateNewAssignmentForm/CreateNewAssignmentForm';
import CreateNewQuizForm from '../../../Forms/CreateNewQuizForm/CreateNewQuizForm';
import CreateNewTopicForm from '../../../Forms/CreateNewTopicForm/CreateNewTopicForm';
import RecheduleContent from '../../../Forms/RecheduleContent/RecheduleContent';
import { parseDate, parseDateForInputField, parseTimeForDate } from '../../../../utilities/DateTimeUtils';
import AddMetaTags from '../../../AddMetaTags/AddMetaTags';
import { Redirect, withRouter } from 'react-router';
import RouteEndPoints from '../../../../utilities/RouteEndPoints';
import TechLogo from '../../../../assets/icons/Tech-Logos.svg';
import AddIcon from '../../../../assets/icons/icon-add-blue.svg';
import Constants from '../../../../utilities/Constants';

import * as actionCreators from '../../../../store/actions/index';
import { connect } from "react-redux";

class ModuleSchedulePage extends React.Component {


    state = {

        weeksList: [],
        newWeekList: [[
            {
                "date": "May 10", "fullDate": "2021-05-04", "dayOff": false, "moduleStart": false, "sessionNumber": 1, "topicsList": []
            },
            {
                "date": "May 11", "fullDate": "2021-05-04", "dayOff": false, "moduleStart": false, "sessionNumber": 1, "topicsList": []
            },
            {
                "date": "May 12", "fullDate": "2021-05-04", "dayOff": false, "moduleStart": false, "sessionNumber": 1, "topicsList": []
            },
            {
                "date": "May 13", "fullDate": "2021-05-04", "dayOff": false, "moduleStart": false, "sessionNumber": 1, "topicsList": []
            },
            {
                "date": "May 14", "fullDate": "2021-05-04", "dayOff": false, "moduleStart": false, "sessionNumber": 1, "topicsList": []
            },
            {
                "date": "May 15", "fullDate": "2021-05-04", "dayOff": false, "moduleStart": false, "sessionNumber": 1, "topicsList": []
            },]
        ],
        showContentLoader: false,
        showCreateAssignmentForm: false,
        showCreateNewQuizForm: false,
        showCreateNewTopicForm: false,
        showPopupLoader: false,
        selectedWeekPos: -1,
        selectedDayPos: -1,
        selectedDate: '',
        addNewWeek: false,
        batchCode: '',
        moduleName: '',
        includeWeekdays: false,
        sendEmails: false,
        showRescheduleForm: false,
        passedDate: '',
        passedDayPos: '',
        passedDate: '',
        passedWeekPos: '',


    }

    addNewButtonRef = React.createRef();

    addNewWeekClicked = () => {
        if (this.addNewButtonRef !== undefined && this.addNewButtonRef !== null) {
            document.body.scrollTop = this.addNewButtonRef.current.offsetTop; // For Safari
            document.documentElement.scrollTop = this.addNewButtonRef.current.offsetTop; // For Chrome, Firefox, IE and Opera
            // console.log('Clicked => ', this.addNewButtonRef, this.addNewButtonRef.current)
        }
    }

    onMarkDayOffOptionClicked = (date) => {
        this.setState({
            showCreateNewTopicForm: false,
            showPopupLoader: false,
            selectedDate: date,
            showRescheduleForm: true,
            passedDate: date,
        });

    }

    markDayOffClicked = (rescheduleContentFormData) => {
        this.setState({ showPopupLoader: true })

        ResourceAPIController.plannerPageMarkDayOff(this.state.batchCode, this.state.moduleName, rescheduleContentFormData)
            .then(response => {
                this.props.onSuccessDialogShow('Day has been marked as off successfully.', 'OKAY');
                this.setState({
                    showPopupLoader: false,
                    showRescheduleForm: false,
                });
                this.getSchedulePageDataBasedOnURL();
            })
            .catch(err => {
                this.setState({ showPopupLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getSelectedDate = (weekPos, dayPos) => {
        let date = '';
        if (weekPos !== -1 && dayPos !== -1 && !IsListEmpty(this.state.weeksList)) {
            date = this.state.weeksList[weekPos][dayPos].fullDate;
        }
        return date;
    }

    createNewTopicClicked = (weekPos, dayPos) => {
        const selectedDate = this.getSelectedDate(weekPos, dayPos);
        this.setState({ showCreateNewTopicForm: true, showPopupLoader: false, selectedWeekPos: weekPos, selectedDayPos: dayPos, selectedDate: selectedDate });
    }

    createNewQuizClicked = (weekPos, dayPos) => {
        const selectedDate = this.getSelectedDate(weekPos, dayPos);
        this.setState({ showCreateNewQuizForm: true, showPopupLoader: false, selectedWeekPos: weekPos, selectedDayPos: dayPos, selectedDate: selectedDate });
    }

    createNewAssignmentClicked = (weekPos, dayPos) => {
        const selectedDate = this.getSelectedDate(weekPos, dayPos);
        this.setState({ showCreateAssignmentForm: true, showPopupLoader: false, selectedWeekPos: weekPos, selectedDayPos: dayPos, selectedDate: selectedDate });
    }

    closePopup = () => {
        this.setState({ showCreateAssignmentForm: false, showCreateNewQuizForm: false, showCreateNewTopicForm: false, showRescheduleForm: false });
    }

    updatedWeeksList = (data, type, id) => {
        let updatedTopic = '';
        if (type === 'topic') {
            updatedTopic = {
                id: id,
                name: data.name,
                type: 'topic',
                scheduledDate: '-'
            }
        } else if (type === 'quiz' || type === 'assignment') {
            updatedTopic = {
                id: id,
                name: data.name,
                type: type,
                scheduledDate: !IsStringEmpty(data.schedule_date) ? parseDate(data.schedule_date, false, true) : '-',
                grades: 0,
                dueDate: !IsStringEmpty(data.due_date) ? parseDate(data.due_date, false, true) : '-',
                dueTime: !IsStringEmpty(data.due_time) ? parseTimeForDate(new Date(data.due_date + ' ' + data.due_time)) : '-',
                submissionsReceived: '-',
                totalStudents: '-'
            }
        }

        let updatedWeeksList = [...this.state.weeksList];
        if (this.state.selectedWeekPos !== -1 && this.state.selectedWeekPos !== -1) {
            updatedWeeksList[this.state.selectedWeekPos][this.state.selectedDayPos].topicsList.push(updatedTopic);
            updatedWeeksList[this.state.selectedWeekPos][this.state.selectedDayPos].dayOff = false;
        }

        return updatedWeeksList;
    }

    createNewAssignment = (assignmentData) => {
        this.setState({ showPopupLoader: true });

        ResourceAPIController.createNewAssignment(this.props.activeProgramBatchCode, this.props.activeModuleName, assignmentData)
            .then(response => {

                this.props.onSuccessDialogShow('Assignment created successfully.', 'OKAY');

                const updatedWeeksList = this.updatedWeeksList(assignmentData, 'assignment', response.result.unit_id);

                this.setState({
                    showPopupLoader: false, showCreateAssignmentForm: false, weeksList: updatedWeeksList
                });

            })
            .catch(err => {
                console.log('Create Assignment Details error => ', err)
                this.setState({ showPopupLoader: false, showCreateAssignmentForm: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    createNewQuiz = (quizData) => {
        this.setState({ showPopupLoader: true });

        let responseObj = null;
        ResourceAPIController.createNewQuiz(this.state.batchCode, this.state.moduleName, quizData)
            .then(response => {
                responseObj = response.result;
                // console.log('Add quiz Details Data => ', responseObj)

                this.props.onSuccessDialogShow('Quiz created successfully.', 'OKAY');

                const updatedWeeksList = this.updatedWeeksList(quizData, 'quiz', response.result.unit_id);
                this.setState({
                    showPopupLoader: false, showCreateNewQuizForm: false, weeksList: updatedWeeksList
                });

            })
            .catch(err => {
                console.log('Create quiz Details error => ', err)
                this.setState({ showPopupLoader: false, showCreateNewQuizForm: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    createNewTopic = (topicData) => {
        this.setState({ showPopupLoader: true });
        let responseObj = null;
        ResourceAPIController.createNewTopic(this.props.params.batchCode, this.props.params.moduleName, topicData)
            .then(response => {
                responseObj = response.result;
                // console.log('Add Topic Details Data => ', responseObj)

                this.props.onSuccessDialogShow('Topic created successfully.', 'OKAY');


                const updatedWeeksList = this.updatedWeeksList(topicData, 'topic', response.result.unit_id);

                this.setState({
                    showPopupLoader: false, showCreateNewTopicForm: false, weeksList: updatedWeeksList
                });

            })
            .catch(err => {
                console.log('Create topic Details error => ', err)
                this.setState({ showPopupLoader: false, showCreateNewTopicForm: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }


    getSchedulerPageData = (batchCode, moduleName) => {
        this.setState({ showContentLoader: true })
        ResourceAPIController.getModulePlannerData(batchCode, moduleName)
            .then(response => {
                let responseObj = response.result;
                // console.log('[ Planner Page ] Get Weeks Data Response => ', responseObj, responseObj.enrolledModules)
                this.setState({ weeksList: responseObj, showContentLoader: false });
            })
            .catch(err => {
                console.log('[ Planner Page ] Get Weeks Data error => ', err)
                this.setState({ showContentLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    isLearner = GetFromLocalStorage(Constants.KEY_IS_LEARNER) === 'true' ? true : false;

    onAddNewWeek = () => {
        this.setState({
            weeksList: [...this.state.weeksList, ...this.state.newWeekList]
        })
    }

    getSchedulePageDataBasedOnURL = () => {
        const batchCode = !IsStringEmpty(this.props.activeProgramBatchCode)
            ? this.props.activeProgramBatchCode
            : this.props.match.params.batchCode;
        const moduleName = !IsStringEmpty(this.props.activeModuleName)
            ? this.props.activeModuleName
            : this.props.match.params.moduleName;

        this.setState({ batchCode: batchCode, moduleName: moduleName });

        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getSchedulerPageData(batchCode, moduleName);
        }

    }

    componentDidMount() {
        // this.props.setupProgramDetailsTopbar(true, false, false);
        this.getSchedulePageDataBasedOnURL();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.getSchedulePageDataBasedOnURL();
        }
    }

    render() {


        const renderWeekCards = !IsListEmpty(this.state.weeksList)
            ? this.state.weeksList.map((week, index) => {
                const weekDaysList = !IsListEmpty(week) ? week.slice(0, 7).map((weekDay, pos) => {

                    return (
                        <WeekDayCard
                            key={pos}
                            date={weekDay.date}
                            fullDate={weekDay.fullDate}
                            dayOff={weekDay.dayOff}
                            moduleStart={weekDay.moduleStart}
                            moduleName={this.state.moduleName}
                            batchCode={this.state.batchCode}
                            data={weekDay.topicsList}
                            weekPos={index}
                            dayPos={pos}
                            markDayOffClicked={this.onMarkDayOffOptionClicked}
                            // markDayOffClicked={this.markDayOffClicked}
                            clearAllClicked={this.clearAllClicked}
                            createNewTopicClicked={this.createNewTopicClicked}
                            createNewQuizClicked={this.createNewQuizClicked}
                            createNewAssignmentClicked={this.createNewAssignmentClicked}
                            isProgramManager={true}
                        />
                    );

                }) : <p className={classes.AddNewButtonContainer}>Week not found = {index}</p>;

                return (
                    <div key={index} className={classes.WeekContainerDiv}>
                        <p className={[classes.WeekName, this.props.fullWidth && classes.WeekNameFullWidth].join(' ')}>Week - {index + 1}</p>
                        <div className={classes.WeekCardsContainer}>
                            {weekDaysList}
                        </div>
                    </div>
                );
                // }) : <p className={classes.NoWeeksFoundText}>Let's create the first week of this module. <br /> Click the button below to add a new week.</p>;
            }) : <p className={classes.NoWeeksFoundText}>Data not available.</p>;

        return (
            <div className={[classes.ModuleSchedulePageContainer, this.props.fullWidth && classes.FullWidth].join(' ')}>

                {this.isLearner ? <Redirect to={RouteEndPoints.UNAUTHORIZED_ERROR} /> : null}

                <AddMetaTags
                    url={window.location.pathname}
                    title={'Schedule Page | Program Manager'}
                />
                {
                    this.state.showCreateNewTopicForm
                        ? <CreateNewTopicForm
                            forEdit={false}
                            selectedDate={this.state.selectedDate}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            createNewTopic={this.createNewTopic}
                        />
                        : null
                }
                {
                    this.state.showRescheduleForm
                        ? <RecheduleContent
                            selectedDate={this.state.selectedDate}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            markDayOffClicked={this.markDayOffClicked}
                        />
                        : null
                }

                {
                    this.state.showCreateAssignmentForm
                        ? <CreateNewAssignmentForm
                            forEdit={false}
                            selectedDate={this.state.selectedDate}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            createNewAssignment={this.createNewAssignment}
                        />
                        : null
                }
                {
                    this.state.showCreateNewQuizForm
                        ? <CreateNewQuizForm
                            forEdit={false}
                            selectedDate={this.state.selectedDate}
                            closePopup={this.closePopup}
                            showLoader={this.state.showPopupLoader}
                            createNewQuiz={this.createNewQuiz}
                        />
                        : null
                }
                {
                    this.state.showContentLoader
                        ? <div className={classes.LoaderContainerDiv}>
                            <span className={classes.HeadingSection}><img src={TechLogo} alt="Module Logo" width="50" /> <h2 className={classes.Heading}>Schedule</h2></span>

                            <div className={classes.LoaderContainer}>
                                <ShowLoader isLoading={true} />
                            </div>
                        </div>
                        : <>
                            <div className={classes.HeadingContainer}>
                                <span className={classes.HeadingSection}><img src={TechLogo} alt="Module Logo" width="50" /><h2 className={classes.Heading}>Schedule</h2></span>
                                {/* <p className={classes.LinkText} onClick={this.addNewWeekClicked}>ADD NEW WEEK</p> */}
                                <div className={classes.DaysContainer}>
                                    <span className={classes.DayName}>MONDAY</span>
                                    <span className={classes.DayName}>TUESDAY</span>
                                    <span className={classes.DayName}>WEDNESDAY</span>
                                    <span className={classes.DayName}>THURSDAY</span>
                                    <span className={classes.DayName}>FRIDAY</span>
                                    <span className={classes.DayName}>SATURDAY</span>
                                    <span className={classes.DayName}>SUNDAY</span>
                                </div>
                            </div>
                            <div className={classes.CurriculumContainer}>

                                <div className={[classes.WeeksContainer, this.props.fullWidth && classes.WeeksFullWidth].join(' ')}>
                                    {renderWeekCards}
                                </div>

                            </div>

                            {/* <div className={[classes.AddNewButtonContainer, this.state.weeksList === [] ? classes.AlignCenter : ''].join(' ')} ref={this.addNewButtonRef} onClick={() => this.onAddNewWeek()}>
                                <img src={AddIcon} alt={'Add New Week'} className={classes.AddNewWeekIcon} />
                                <p>Add New Week</p>
                            </div> */}
                        </>
                }

            </div>
        );
    }
}

const mapStateToProps = state => {
    return {

        showSuccessDialog: state.showSuccessDialog,
        successDialogMessage: state.successDialogMessage,
        successDialogButtonLabel: state.successDialogButtonLabel,
        showFailureDialog: state.showFailureDialog,
        failureDialogMessage: state.failureDialogMessage,
        failureDialogButtonLabel: state.failureDialogButtonLabel,
        somethingWentWrong: state.somethingWentWrong,
        notFound: state.notFound,
        unauthorized: state.unauthorized,
    }
}

const mapDisptachToProps = dispatch => {
    return {
        setTopbarTheme: () => dispatch(actionCreators.setTopbarTheme('Light')),

        setupProgramDetailsTopbar: (showTopbar, showProgramProgress, showModuleProgress) => dispatch(actionCreators.setupProgramDetailsTopbar(showTopbar, showProgramProgress, showModuleProgress)),

        onFailureDialogShow: (msg, btnLabel) => dispatch(actionCreators.onFailureDialogShow(msg, btnLabel)),
        onFailureDialogHide: () => dispatch(actionCreators.onFailureDialogHide()),
        onSuccessDialogShow: (msg, btnLabel) => dispatch(actionCreators.onSuccessDialogShow(msg, btnLabel)),
        onSuccessDialogHide: () => dispatch(actionCreators.onSuccessDialogHide()),

        redirectToUnauthorized: () => dispatch(actionCreators.redirectToUnauthorized()),
        redirectToNotFound: () => dispatch(actionCreators.redirectToNotFound()),
        redirectToServerError: () => dispatch(actionCreators.redirectToServerError()),
        showSessionExpiredDialog: (show) => dispatch(actionCreators.showSessionExpiredDialog(show))

    }
}

export default connect(mapStateToProps, mapDisptachToProps)(withRouter(ModuleSchedulePage));